import { clientApi } from 'api';
import { IArticle } from 'server/models/Article/types';

export const updateArticle = (isServer = false) => async (data: FormData, id?: string) => {
  const response = await clientApi.patch<IArticle>(`/blog/${id}`, data);

  return response;
};
